import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { catchError, throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const isSessionRequest = req.url.includes('/api/auth/session');
  return next(req).pipe(catchError((error) => {
    if (error.status === 401 && !isSessionRequest && !router.url.startsWith('/public')) {
      authService.clearSession();
      router.navigate(['/auth/sign-in']);
    }
    return throwError(() => error);
  }));
};
